// SPA mode: no SSR, no prerendering.
// Aplikasi EKINKINIAN berjalan sepenuhnya client-side (offline-first).
export const ssr = false;
export const prerender = false;
